import React, { forwardRef } from 'react';

type Props = {
    children: React.ReactNode;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'children'>;

const PropagationStopper = forwardRef<HTMLDivElement, Props>(
    function PropagationStopper({ children, onClick, ...rest }, ref) {
        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <div
                ref={ref}
                {...rest}
                onClick={event => {
                    event.stopPropagation();
                    onClick?.(event);
                }}
            >
                {children}
            </div>
        );
    },
);

export default PropagationStopper;
